module.exports = __webpack_public_path__ + "static/media/dientes_separados.7d1f0b98.svg";